
import React from 'react'
import {mdx} from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag mdx.Fragment */
import withLayout from 'nextra-theme-mui-docs';
import {withSSG} from 'nextra/ssg';
import layoutConfig from '/vercel/path0/docs/theme.config.js';
import CodeExample from 'nextra-theme-mui-docs/CodeExample';
import Basic from '../../examples/DataFilter/Basic';
import srcBasic from '../../examples/DataFilter/Basic?raw';
import CustomOperator from '../../examples/DataFilter/CustomOperator';
import srcCustomOperator from '../../examples/DataFilter/CustomOperator?raw';
import DifferentSizes from '../../examples/DataFilter/DifferentSizes';
import srcDifferentSizes from '../../examples/DataFilter/DifferentSizes?raw';
const MDXLayout = function NextraPage(props) {
  return withSSG(withLayout({
    filename: "DataFilter.mdx",
    route: "/components/DataFilter",
    meta: {
      "title": "DataFilter"
    },
    pageMap: [{
      "name": "component-api",
      "children": [{
        "name": "DataFilter",
        "route": "/component-api/DataFilter"
      }, {
        "name": "DataGrid",
        "route": "/component-api/DataGrid"
      }, {
        "name": "Sparkbars",
        "route": "/component-api/Sparkbars"
      }, {
        "name": "Sparkline",
        "route": "/component-api/Sparkline"
      }],
      "route": "/component-api"
    }, {
      "name": "components",
      "children": [{
        "name": "DataFilter",
        "route": "/components/DataFilter",
        "frontMatter": {
          "title": "DataFilter"
        }
      }, {
        "name": "DataGrid",
        "children": [{
          "name": "columns",
          "route": "/components/DataGrid/columns",
          "frontMatter": {
            "title": "Columns"
          }
        }, {
          "name": "index",
          "route": "/components/DataGrid",
          "frontMatter": {
            "title": "Basic Usage",
            "description": "Lorem ipsum dolor sit amet.",
            "order": ["index"]
          }
        }, {
          "name": "virtualization",
          "route": "/components/DataGrid/virtualization",
          "frontMatter": {
            "title": "Virtualization",
            "description": "Lorem ipsum dolor sit amet."
          }
        }],
        "route": "/components/DataGrid"
      }, {
        "name": "SelectionList",
        "route": "/components/SelectionList",
        "frontMatter": {
          "title": "Introduction",
          "hidden": true
        }
      }, {
        "name": "Sparkbars",
        "route": "/components/Sparkbars",
        "frontMatter": {
          "title": "Sparkbars"
        }
      }, {
        "name": "Sparkline",
        "route": "/components/Sparkline",
        "frontMatter": {
          "title": "Sparkline"
        }
      }, {
        "name": "visx",
        "route": "/components/visx"
      }],
      "route": "/components"
    }, {
      "name": "index",
      "route": "/",
      "frontMatter": {
        "title": "Introduction",
        "order": ["index", {
          "name": "components",
          "title": "Components"
        }, {
          "name": "component-api",
          "title": "Component Api"
        }, {
          "name": "more",
          "title": "More"
        }]
      }
    }, {
      "name": "more",
      "children": [{
        "name": "markdown",
        "route": "/more/markdown",
        "frontMatter": {
          "hidden": true
        }
      }, {
        "name": "nextra-theme-mui-docs",
        "route": "/more/nextra-theme-mui-docs"
      }],
      "route": "/more"
    }]
  }, layoutConfig))(props);
};
function MDXContent({components, ...props}) {
  return <MDXLayout components={components} {...props}><h1>{"DataFilter"}</h1><p>{"A rich interface to create data filters. Filters are represented as a set of operations on individual fields of the data records. Each operation is represented by a "}<inlineCode parentName="p">{"Chip"}</inlineCode>{"."}</p><h2>{"Basic DataFilter"}</h2>{"\n"}<CodeExample src={srcBasic} mdxType="CodeExample"><Basic parentName="CodeExample" mdxType="Basic" /></CodeExample><h2>{"Custom Operators"}</h2><p>{"You can define your own operators."}</p>{"\n"}<CodeExample src={srcCustomOperator} mdxType="CodeExample"><CustomOperator parentName="CodeExample" mdxType="CustomOperator" /></CodeExample><h2>{"Different Sizes"}</h2><p>{"The "}<inlineCode parentName="p">{"DataFilter"}</inlineCode>{" component supports different sizes through the "}<inlineCode parentName="p">{"size"}</inlineCode>{" property."}</p>{"\n"}<CodeExample src={srcDifferentSizes} mdxType="CodeExample"><DifferentSizes parentName="CodeExample" mdxType="DifferentSizes" /></CodeExample></MDXLayout>;
}
MDXContent.isMDXComponent = true;
export default MDXContent;
